import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const TravelTransportIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "TravelTransportIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M20.6377 17.9404H3.36288C2.61168 17.9404 2.00008 17.3288 2.00008 16.5776V11.5925C2.00008 11.3142 2.22525 11.0891 2.50351 11.0891H18.1835C18.4244 11.0891 18.6614 11.1274 18.8875 11.2041L21.0684 11.9307C21.6254 12.1166 22 12.6367 22 13.2237V16.5776C22 17.3288 21.3889 17.9404 20.6377 17.9404ZM3.00694 12.0959V16.5776C3.00694 16.7743 3.16672 16.9336 3.36288 16.9336H20.6377C20.8339 16.9336 20.9932 16.7743 20.9932 16.5776V13.2237C20.9932 13.0703 20.8953 12.9347 20.7498 12.8865L18.5675 12.1589C18.4436 12.1166 18.3148 12.0959 18.1835 12.0959H3.00694Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M18.4622 12.0959H2.50351C2.30981 12.0959 2.13283 11.9848 2.04925 11.8098C1.96567 11.6348 1.98976 11.4273 2.11168 11.2769L5.2586 7.37335C5.35398 7.25438 5.49802 7.18555 5.65042 7.18555H16.4392C16.6275 7.18555 16.7996 7.29076 16.8861 7.45693L18.9091 11.3605C18.9903 11.5168 18.9839 11.7036 18.8924 11.854C18.801 12.0045 18.6383 12.0959 18.4622 12.0959ZM3.55609 11.0891H17.6343L16.1329 8.19241H5.89132L3.55609 11.0891Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M12.0003 12.0959C11.722 12.0959 11.4969 11.8708 11.4969 11.5925V7.68898C11.4969 7.41072 11.722 7.18555 12.0003 7.18555C12.2786 7.18555 12.5037 7.41072 12.5037 7.68898V11.5925C12.5037 11.8708 12.2786 12.0959 12.0003 12.0959Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M6.99895 12.0959C6.72069 12.0959 6.49553 11.8708 6.49553 11.5925V7.68898C6.49553 7.41072 6.72069 7.18555 6.99895 7.18555C7.27722 7.18555 7.50238 7.41072 7.50238 7.68898V11.5925C7.50238 11.8708 7.27722 12.0959 6.99895 12.0959Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M13.1241 8.19241H10.8764C10.5982 8.19241 10.373 7.96725 10.373 7.68898V6.0853C10.373 5.18758 11.1031 4.45801 12.0003 4.45801C12.8975 4.45801 13.6276 5.18758 13.6276 6.0853V7.68898C13.6276 7.96725 13.4024 8.19241 13.1241 8.19241ZM11.3799 7.18555H12.6207V6.0853C12.6207 5.74313 12.3425 5.46486 12.0003 5.46486C11.6581 5.46486 11.3799 5.74313 11.3799 6.0853V7.18555Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M17.7037 19.5421C16.5429 19.5421 15.599 18.5982 15.599 17.437C15.599 16.2758 16.5429 15.3318 17.7037 15.3318C18.8644 15.3318 19.8088 16.2758 19.8088 17.437C19.8088 18.5982 18.8644 19.5421 17.7037 19.5421ZM17.7037 16.3387C17.0985 16.3387 16.6059 16.8313 16.6059 17.437C16.6059 18.0427 17.0985 18.5353 17.7037 18.5353C18.3093 18.5353 18.802 18.0427 18.802 17.437C18.802 16.8313 18.3093 16.3387 17.7037 16.3387Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M5.39772 19.5421C4.23699 19.5421 3.29257 18.5982 3.29257 17.437C3.29257 16.2758 4.23699 15.3318 5.39772 15.3318C6.55845 15.3318 7.50238 16.2758 7.50238 17.437C7.50238 18.5982 6.55845 19.5421 5.39772 19.5421ZM5.39772 16.3387C4.79204 16.3387 4.29943 16.8313 4.29943 17.437C4.29943 18.0427 4.79204 18.5353 5.39772 18.5353C6.00291 18.5353 6.49553 18.0427 6.49553 17.437C6.49553 16.8313 6.00291 16.3387 5.39772 16.3387Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M4.52656 14.1755H2.50351C2.22525 14.1755 2.00008 13.9504 2.00008 13.6721C2.00008 13.3938 2.22525 13.1687 2.50351 13.1687H4.52656C4.80483 13.1687 5.02999 13.3938 5.02999 13.6721C5.02999 13.9504 4.80483 14.1755 4.52656 14.1755Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M9.58394 14.5541C9.30568 14.5541 9.08051 14.3289 9.08051 14.0506V13.2926C9.08051 13.0143 9.30568 12.7891 9.58394 12.7891C9.8622 12.7891 10.0874 13.0143 10.0874 13.2926V14.0506C10.0874 14.3289 9.8622 14.5541 9.58394 14.5541Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M12.0003 14.5541C11.722 14.5541 11.4969 14.3289 11.4969 14.0506V13.2926C11.4969 13.0143 11.722 12.7891 12.0003 12.7891C12.2786 12.7891 12.5037 13.0143 12.5037 13.2926V14.0506C12.5037 14.3289 12.2786 14.5541 12.0003 14.5541Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M14.4166 14.5541C14.1384 14.5541 13.9132 14.3289 13.9132 14.0506V13.2926C13.9132 13.0143 14.1384 12.7891 14.4166 12.7891C14.6949 12.7891 14.9201 13.0143 14.9201 13.2926V14.0506C14.9201 14.3289 14.6949 14.5541 14.4166 14.5541Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M10.7919 16.3387C10.5136 16.3387 10.2884 16.1135 10.2884 15.8353V15.0762C10.2884 14.7979 10.5136 14.5728 10.7919 14.5728C11.0701 14.5728 11.2953 14.7979 11.2953 15.0762V15.8353C11.2953 16.1135 11.0701 16.3387 10.7919 16.3387Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M13.2082 16.3387C12.93 16.3387 12.7048 16.1135 12.7048 15.8353V15.0762C12.7048 14.7979 12.93 14.5728 13.2082 14.5728C13.4865 14.5728 13.7116 14.7979 13.7116 15.0762V15.8353C13.7116 16.1135 13.4865 16.3387 13.2082 16.3387Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default TravelTransportIcon;
